import {
  type IConversationRepository,
  type ConversationStreamHandlers,
} from '../../interfaces/IConversationRepository'
import { type ConversationTurnPayload } from '../../types/ConversationTurnPayload'

interface Dependency {
  conversationRepository: IConversationRepository
}

export class RunConversationTurnUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = (
    payload: ConversationTurnPayload,
    handlers: ConversationStreamHandlers
  ): (() => void) =>
    this.deps.conversationRepository.openTurn(payload, handlers)
}
